import { InputCheckbox } from "@silversea-ssc/ui-components-react";
import React from "react";
import { connectToggleRefinement } from "react-instantsearch-dom";

interface InlineToggleFilterProps {
  id: string;
  attribute: string;
  label: string;
  value: string | number;
  dataContentPiece?: string;
}

// WARNING: this should be exported by @types/react-instantsearch
interface ToggleRefinementProps {
  currentRefinement: boolean;
  count: {
    checked: number;
    unchecked: number;
  };
  refine: (boolean) => void;
  dataContentPiece?: string;
}

const ToggleRefinement: React.FC<
  InlineToggleFilterProps & ToggleRefinementProps
> = ({
  currentRefinement,
  refine,
  count,
  label,
  value,
  id,
  dataContentPiece
}) => {
  return (
    <InputCheckbox
      checked={currentRefinement}
      position="Right"
      value={value}
      id={id}
      width="full"
      disabled={(count.unchecked || 0) <= 0}
      onChange={(event) => {
        refine(event.target.checked);
      }}
      data-content-piece={dataContentPiece}
    >
      {label} ({count.unchecked || 0})
    </InputCheckbox>
  );
};

const InlineToggleFilter: React.ComponentType<InlineToggleFilterProps> = connectToggleRefinement(
  ToggleRefinement
);
export default InlineToggleFilter;
